import useGlobalState, { GlobalStateType } from '@aurora/shared-client/helpers/ui/GlobalState';
import type { RouteInfo } from '@aurora/shared-types/community';
import {
  dispatchRouteChangedEvent,
  dispatchRouteChangeEvent
} from '@aurora/shared-utils/helpers/events/EventHelper';
import { useEffect, useRef } from 'react';

/**
 * This hook stores the previous route info in a global state
 *
 * @param pathInfo path info
 */
export default function usePreviousRouteInfo(pathInfo: RouteInfo): void {
  const [, setPreviousPathInfo] = useGlobalState<GlobalStateType>(
    GlobalStateType.PREVIOUS_ROUTE_INFO
  );

  const previousRouteInfoRef = useRef<RouteInfo | null>(null);

  useEffect(() => {
    if (pathInfo !== previousRouteInfoRef.current) {
      //if the route changes, fire an event for any custom Javascript listeners
      if (previousRouteInfoRef.current) {
        dispatchRouteChangeEvent(pathInfo, previousRouteInfoRef.current);

        function doDispatchRouteChangedEvent() {
          dispatchRouteChangedEvent(pathInfo, previousRouteInfoRef.current);
        }

        function handleDOMContentLoaded() {
          doDispatchRouteChangedEvent();
          document.removeEventListener('DOMContentLoaded', handleDOMContentLoaded);
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);
        } else {
          doDispatchRouteChangedEvent();
        }
      }
      // Update previousPath in global state with the previous path
      setPreviousPathInfo(previousRouteInfoRef.current);
      // Update the ref to current path for next comparison
      previousRouteInfoRef.current = pathInfo;
    }
  }, [pathInfo, setPreviousPathInfo]);
}
